import Flex from '@deprecated-ui/common/Flex';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

const ContainerBasicScreener = styled.div`
  position: relative;
  width: 100%;
  display: flex;

  .ant-select-selector {
    border-radius: 3px !important;
  }

  & > button {
    border-radius: 3px;
  }
  & > input {
    border-radius: 3px !important;
  }
  & > .icon-trading_delete {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0px 8px;
  }
`;

const ContainerScreenerRules = styled(Flex).attrs({
  align: 'center',
  width: '100%',
  mr: '8px',
  direction: 'column',
})`
  row-gap: 15px;
`;

const IconRemove = styled(Iconmoon).attrs({
  className: 'icon-toolbar_delete',
  color: color.sunsetOrange,
})`
  font-weight: bold;
  display: flex;
  align-items: center;
  padding-left: 9px;
`;

const SSelect = styled.select`
  border: 1px solid ${color.gainsboro};
  padding: 2px 4px;
  margin: 0 10px;
  border-radius: 3px;
`;

export { ContainerBasicScreener, ContainerScreenerRules, IconRemove, SSelect };
